import { useTranslation } from "@coworker/locales";
import TaskInfoModal from "./TaskInfoModal";
import MfaqFollowUpGraph from "./MfaqFollowUpGraph";

type Props = {
  visible: boolean;
  onClose: () => void;
};

function MfaqInfoModalContent({ visible, onClose }: Props) {
  const { t } = useTranslation();
  const description = `${t("mfaqFollowUpTaskExplanation1String")}\n\n${t("mfaqFollowUpTaskExplanation2String")}`;
  return (
    <TaskInfoModal
      visible={visible}
      onClose={onClose}
      title={t("aboutMFAQString")}
      heading={t("mfaqFollowUpTaskString")}
      description={description}
      illustration={<MfaqFollowUpGraph />}
    />
  );
}

MfaqInfoModalContent.buttonAriaLabelKey =
  "mfaqTaskInfoButtonAriaLabelString" as const;

export default MfaqInfoModalContent;
